/**
 * 予約日数を返す
 * @param date1 // 利用開始日
 * @param date2 // 利用終了日
 * @return {number} // 予約日数
 */
export const calculateDaysBetween = (date1: string, date2: string): number => {
  // Date.parseメソッドを使用して日付文字列をミリ秒に変換
  const timeStamp1 = Date.parse(date1)
  const timeStamp2 = Date.parse(date2)

  // 二つの日付の差分をミリ秒で計算
  const diffInMilliSeconds = Math.abs(timeStamp2 - timeStamp1)

  // 差分をミリ秒から日に変換(1日 = 24*60*60*1000 ミリ秒)
  const diffInDays = diffInMilliSeconds / (24 * 60 * 60 * 1000)

  return Math.round(diffInDays) + 1
}

/**
 * 開始日と終了日を受け取り、その間のすべての日付を含む配列を返す
 * @param start 開始日
 * @param end 終了日
 * @returns ["YYYY-MM-DD", "YYYY-MM-DD", ....]
 */
export const getDatesBetween = (start: string, end: string): string[] => {
  const dateArray: string[] = []
  const currentDate = new Date(start)

  while (currentDate <= new Date(end)) {
    dateArray.push(currentDate.toISOString().split('T')[0]) // YYYY-MM-DD形式の文字列を追加
    currentDate.setDate(currentDate.getDate() + 1) // 日付を1日進める
  }

  return dateArray
}

/**
 * 予約の開始時間と終了時間を受け取り、利用時間を返す
 * @param time1  // 開始時間
 * @param time2  // 終了時間
 * @return 分単位の利用時間
 */
export const calculateMinutes = (time1: string, time2: string): number => {
  if (!time1 || !time2) return 0
  // 'hh:mm'形式をパースしてDateオブジェクトを作成
  const [hours1, minutes1] = time1.split(':').map(Number)
  const [hours2, minutes2] = time2.split(':').map(Number)

  const date1 = new Date()
  date1.setHours(hours1, minutes1)
  date1.setFullYear(1970, 0, 1) // 日付をリセット

  const date2 = new Date()
  date2.setHours(hours2, minutes2)
  date2.setFullYear(1970, 0, 1) // 日付をリセット

  // 2つの日付の差をミリ秒で取得し、ミリ秒を分に変換
  let diff = Math.abs((date2.getTime() - date1.getTime()) / 1000 / 60)

  // 結果を小数点第2位まで丸める
  diff = Math.round(diff * 100) / 100

  return diff
}

/**
 * YYYY-MM-DD形式の文字列を受け取り、YYYY/MM/DD形式の文字列を返す
 * @param dateString
 * @returns
 */
export const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)

  return `${year}/${month}/${day}`
}

export const convertPrefCode = (zipcode: string): string => {
  const map: { [key: string]: string } = {
    '1': 'HK',
    '2': 'AO',
    '3': 'IT',
    '4': 'MG',
    '5': 'AK',
    '6': 'YG',
    '7': 'FS',
    '8': 'IB',
    '9': 'TC',
    '10': 'GU',
    '11': 'ST',
    '12': 'CB',
    '13': 'TY',
    '14': 'KN',
    '15': 'NI',
    '16': 'TM',
    '17': 'IS',
    '18': 'FI',
    '19': 'YN',
    '20': 'NA',
    '21': 'GI',
    '22': 'SZ',
    '23': 'AI',
    '24': 'ME',
    '25': 'SI',
    '26': 'KY',
    '27': 'OS',
    '28': 'HG',
    '29': 'NR',
    '30': 'WA',
    '31': 'TT',
    '32': 'SN',
    '33': 'OY',
    '34': 'HS',
    '35': 'YA',
    '36': 'TK',
    '37': 'KA',
    '38': 'EH',
    '39': 'KO',
    '40': 'FO',
    '41': 'SG',
    '42': 'NS',
    '43': 'KU',
    '44': 'OI',
    '45': 'MZ',
    '46': 'KG',
    '47': 'OK',
  }

  return map[zipcode] || ''
}
